import React from 'react';
import PropTypes from 'prop-types';
import { string } from 'yup';
import BaseInput from '../base';

const FirstName = props => (
  <BaseInput
    label="First Name"
    type="text"
    name="first"
    inputTip="enter exactly as it appears on your driver&#39;s license"
    transparent
    data-cv-test="firstName"
    validate={val =>
      string()
        .required('Enter your first name')
        .max(30, 'First name cannot be greater than 30 characters')
        .matches(/^[a-zA-Z0-9 \-']+$/, {
          message: 'Enter a valid first name',
          excludeEmptyString: true
        })
        .validate(val)
        .then(() => null)
        .catch(err => err.errors.join(', '))
    }
    {...props}
  />
);

FirstName.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
};

FirstName.defaultProps = {
  error: false
};

export default FirstName;
